'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('housing_preservation', {
      url: '/account/housing/housing_preservation?jurisdiction&sta_recid&policyName',
      template: '<housing-preservation></housing-preservation>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null,      // Default value if not provided
        policyName: null     // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/housing_preservation/housing_preservation.routes.js